import React, { useState } from "react";
import MyWorks from "../MyWorks/MyWorks";
import "./MyProtfolio.css";
import AOS from "aos";
import "aos/dist/aos.css";
import ProjectData from "../../utiliti/projectData";
const MyPortfolio = ({ handleDetailsProject }) => {
  const [data, setData] = useState(ProjectData);
  const [currentCat, setCurrentCat] = useState("all");

  const handleFilter = (cate) => {
    setCurrentCat(cate);
    setData([]);
    const updatedItem = ProjectData.filter((currEle) => {
      return currEle.category === cate;
    });
    setData(updatedItem);
  };

  AOS.init({
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 500,
  });

  return (
    <div id="portfolio" className="pt-24 ">
      <div className=" mx-auto relative after:absolute after:content-['Portfolio']  after:tracking-widest after:text-own-gray-black after:text-[4rem]   sm:after:text-[8rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] after:-top-[40px] after:-z-10  MyContainer text-center p-5">
        <span className="text-sm bg-own-primary bg-opacity-50 px-8 py-3  border-b-[2px] border-own-border-color border-opacity-20 text-own-gray-white inline-block tracking-widest mb-2 animate-bounce ">
          VISIT MY PROJECT AND KEEP YOUR FEEDBACK
        </span>
        <h2 className="md:text-5xl text-3xl mb-3 font-extrabold text-own-secondary rounded-md   block">
          My Portfolios
        </h2>
        <div className="my-7 container">
          <ul className="flex md:flex-row flex-col md:item-center text-left md:justify-center ">
            <li
              onClick={() => {
                setCurrentCat("all");
                setData(ProjectData);
              }}
              className={
                currentCat === "all"
                  ? "mx-5 bg-own-primary px-4 py-1 rounded-md  border-[1px] border-own-secondary  cursor-pointer "
                  : "mx-5 bg-own-primary px-4 py-1 rounded-md text-own-gray-white border-[1px] border-own-border-color border-opacity-10 cursor-pointer"
              }
            >
              <span
                className={
                  currentCat === "all"
                    ? "text-own-secondary font-medium cursor-pointer"
                    : "text-own-gray-white font-medium cursor-pointer"
                }
              >
                All
              </span>
            </li>

            <li
              onClick={() => handleFilter("MERN")}
              className={
                currentCat === "MERN"
                  ? "mx-5 bg-own-primary px-4 py-1 rounded-md  border-[1px] border-own-secondary  cursor-pointer "
                  : "mx-5 bg-own-primary px-4 py-1 rounded-md text-own-gray-white border-[1px] border-own-border-color border-opacity-10 cursor-pointer"
              }
            >
              <span
                className={
                  currentCat === "MERN"
                    ? "text-own-secondary font-medium cursor-pointer"
                    : "text-own-gray-white font-medium cursor-pointer"
                }
              >
                MERN Stack
              </span>
            </li>
            <li
              onClick={() => handleFilter("next")}
              className={
                currentCat === "next"
                  ? "mx-5 bg-own-primary px-4 py-1 rounded-md  border-[1px] border-own-secondary  cursor-pointer "
                  : "mx-5 bg-own-primary px-4 py-1 rounded-md text-own-gray-white border-[1px] border-own-border-color border-opacity-10 cursor-pointer"
              }
            >
              <span
                className={
                  currentCat === "next"
                    ? "text-own-secondary font-medium cursor-pointer"
                    : "text-own-gray-white font-medium cursor-pointer"
                }
              >
                Next Js
              </span>
            </li>
            <li
              onClick={() => handleFilter("junior")}
              className={
                currentCat === "junior"
                  ? "mx-5 bg-own-primary px-4 py-1 rounded-md  border-[1px] border-own-secondary  cursor-pointer "
                  : "mx-5 bg-own-primary px-4 py-1 rounded-md text-own-gray-white border-[1px] border-own-border-color border-opacity-10 cursor-pointer"
              }
            >
              <span
                className={
                  currentCat === "junior"
                    ? "text-own-secondary font-medium cursor-pointer"
                    : "text-own-gray-white font-medium cursor-pointer"
                }
              >
                Junior Project
              </span>
            </li>
          </ul>
        </div>
        <div className="grid relative md:grid-cols-2 lg:grid-cols-3 sm:gap-10 px-4 sm:px-10">
          {/* {loading ? <DataLoading /> : null} */}

          {data?.map((projectData) => (
            <MyWorks
              handleDetailsProject={handleDetailsProject}
              data={projectData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyPortfolio;
